import type { KeyValueStore } from '../env/PlaybackEnv'

export const localStorageStore: KeyValueStore = {
    getItem: (key) => localStorage.getItem(key),
    setItem: (key, value) => localStorage.setItem(key, value),
    removeItem: (key) => localStorage.removeItem(key),
}
